import { render, staticRenderFns } from "./UserNotificationsSubscription.vue?vue&type=template&id=7aec2c89&"
import script from "./UserNotificationsSubscription.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports